import React from 'react';
import { Flex, Heading, Text, Box, Table } from '@magicpatterns/cubed';
const subprocessors = [{
  name: 'Anthropic',
  logo: 'https://upload.wikimedia.org/wikipedia/commons/7/78/Anthropic_logo.svg',
  description: 'AI model provider powering intelligent code generation and design assistance.',
  location: 'United States'
}, {
  name: 'Google Gemini',
  logo: 'https://www.gstatic.com/lamda/images/gemini_sparkle_v002_d4735304ff6292a690345.svg',
  description: 'AI model provider for multimodal understanding and content generation.',
  location: 'United States'
}, {
  name: 'Stripe',
  logo: 'https://cdn.worldvectorlogo.com/logos/stripe-4.svg',
  description: 'Payment processing and billing infrastructure for subscription management.',
  location: 'United States'
}, {
  name: 'WorkOS',
  logo: 'https://images.prismic.io/sacra/aNR4255xUNkB1FA6_workos-logo.png?auto=format,compress',
  description: 'Enterprise authentication, SSO, and directory sync provider.',
  location: 'United States'
}, {
  name: 'MongoDB',
  logo: 'https://cdn.worldvectorlogo.com/logos/mongodb-icon-2.svg',
  description: 'Cloud database service for application data storage and management.',
  location: 'United States'
}, {
  name: 'Vercel',
  logo: 'https://cdn.worldvectorlogo.com/logos/vercel.svg',
  description: 'Cloud platform for frontend deployment, hosting, and edge computing.',
  location: 'United States'
}, {
  name: 'Render',
  logo: 'https://avatars.githubusercontent.com/u/36424661',
  description: 'Cloud infrastructure platform for backend services and application hosting.',
  location: 'United States'
}];
export function SubprocessorsSection() {
  return <Flex direction="column" gap="5" data-id="element-59">
      <Box data-id="element-60">
        <Heading size="5" mb="2" data-id="element-61">
          Subprocessors
        </Heading>
        <Text size="3" color="gray" data-id="element-62">
          Third-party services that process data on our behalf. All
          subprocessors are located in the United States.
        </Text>
      </Box>

      <Table.Root variant="surface" size="2" data-id="element-63">
        <Table.Header data-id="element-64">
          <Table.Row data-id="element-65">
            <Table.ColumnHeaderCell data-id="element-66">Subprocessor</Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell className="hidden sm:table-cell" data-id="element-67">
              Description
            </Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell data-id="element-68">Location</Table.ColumnHeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body data-id="element-69">
          {subprocessors.map(sp => <Table.Row key={sp.name} data-id="element-70">
              <Table.RowHeaderCell data-id="element-71">
                <Flex align="center" gap="3" data-id="element-72">
                  <img src={sp.logo} alt={`${sp.name} logo`} className="w-6 h-6 object-contain flex-shrink-0" data-id="element-73" />
                  <Text size="2" weight="medium" data-id="element-74">
                    {sp.name}
                  </Text>
                </Flex>
              </Table.RowHeaderCell>
              <Table.Cell className="hidden sm:table-cell" data-id="element-75">
                <Text size="2" color="gray" data-id="element-76">
                  {sp.description}
                </Text>
              </Table.Cell>
              <Table.Cell data-id="element-77">
                <Text size="2" color="gray" data-id="element-78">
                  {sp.location}
                </Text>
              </Table.Cell>
            </Table.Row>)}
        </Table.Body>
      </Table.Root>
    </Flex>;
}